<template>
  <main class="signout-page">
    <section class="signout-card" aria-labelledby="signout-title">
      <img
        src="/mmoser-associates.svg"
        class="signout-brand"
        alt="M Moser Associates"
      >

      <div class="signout-icon" aria-hidden="true">
        <i class="fa-solid fa-arrow-right-from-bracket"></i>
      </div>

      <p class="signout-eyebrow">Logged out</p>
      <h1 id="signout-title">You’re logged out</h1>
      <p class="signout-message">
        You have successfully logged out of Lens.
      </p>

      <button type="button" class="signout-action" @click="LogIn">
        Return to dashboard
        <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
      </button>
    </section>
  </main>
</template>


<script>

import { useCookies } from "vue3-cookies"
export default {
    name : 'SignOut',
    mounted (){
        const { cookies } = useCookies()
        if(this.signoutParam=='yes'){
            cookies.remove('_auzer')
        }
    },
    data(){
        return {
            signoutParam : this.$route.query.signout
        }
    },
    methods : {
        LogIn(){
            window.location.assign('https://cms-staging.azurewebsites.net/project/dashboard')
        }
    }
}
</script>

<style scoped>
.signout-page {
    --signout-navy: #173d46;
    --signout-orange: #f15a24;
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 3rem 1.5rem;
    background:
        radial-gradient(circle at 18% 18%, rgba(79, 190, 195, 0.14), transparent 30%),
        radial-gradient(circle at 82% 78%, rgba(241, 90, 36, 0.1), transparent 28%),
        #f4f8f9;
}

.signout-card {
    width: min(100%, 34rem);
    padding: 3rem;
    text-align: center;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(23, 61, 70, 0.1);
    border-radius: 1.25rem;
    box-shadow: 0 1.5rem 4rem rgba(23, 61, 70, 0.12);
}

.signout-brand {
    display: block;
    width: 11.5rem;
    max-width: 65%;
    height: auto;
    margin: 0 auto 2.25rem;
}

.signout-icon {
    width: 5rem;
    height: 5rem;
    display: grid;
    place-items: center;
    margin: 0 auto 1.75rem;
    color: var(--signout-orange);
    font-size: 1.75rem;
    background: rgba(241, 90, 36, 0.1);
    border-radius: 50%;
}

.signout-eyebrow {
    margin-bottom: 0.6rem;
    color: var(--signout-orange);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
}

.signout-card h1 {
    margin-bottom: 0.8rem;
    color: var(--signout-navy);
    font-size: clamp(2rem, 5vw, 2.6rem);
    font-weight: 700;
    letter-spacing: -0.035em;
}

.signout-message {
    max-width: 27rem;
    margin: 0 auto 2rem;
    color: #60737a;
    font-size: 1rem;
    line-height: 1.65;
}

.signout-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    min-height: 3rem;
    padding: 0.75rem 1.4rem;
    color: #fff;
    font-weight: 600;
    background: var(--signout-navy);
    border: 0;
    border-radius: 0.65rem;
    box-shadow: 0 0.65rem 1.25rem rgba(23, 61, 70, 0.2);
    transition: transform 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

.signout-action:hover {
    background: #0f3038;
    box-shadow: 0 0.8rem 1.5rem rgba(23, 61, 70, 0.25);
    transform: translateY(-2px);
}

.signout-action:focus-visible {
    outline: 3px solid rgba(241, 90, 36, 0.35);
    outline-offset: 4px;
}

@media (max-width: 576px) {
    .signout-page {
        padding: 1.5rem 1rem;
    }

    .signout-card {
        padding: 2.25rem 1.5rem;
        border-radius: 1rem;
    }
}
</style>
